export default __webpack_public_path__ + "static/media/appicon-placeholder.9199e9f5.svg";